import React, { useEffect, useRef } from 'react';
import bundle from '../marketing/marketing.generated.json';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Bungee&family=Bungee+Shade&family=Modak&family=Permanent+Marker&family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap';

/**
 * Public marketing homepage ("/"). The founder-approved prototype is ported
 * verbatim (markup + CSS + JS) and mounted as a React component: CSS/JS are
 * injected on mount and fully torn down on unmount (listeners removed via the
 * bundle's __mktCleanup shim) so nothing bleeds onto the logged-in app.
 */
export default function MarketingSite() {
  const hostRef = useRef(null);

  useEffect(() => {
    window.__MKT_API = API;
    const prevTitle = document.title;
    document.title = 'MusicBooth — Your venue. Our vibe.';

    // Google Fonts (display fonts used by the prototype)
    const fonts = document.createElement('link');
    fonts.rel = 'stylesheet';
    fonts.href = FONTS_HREF;
    fonts.setAttribute('data-mkt', '1');
    document.head.appendChild(fonts);

    // Scoped stylesheet
    const style = document.createElement('style');
    style.setAttribute('data-mkt', '1');
    style.textContent = bundle.css;
    document.head.appendChild(style);

    // Markup
    if (hostRef.current) hostRef.current.innerHTML = bundle.body;

    // Behaviour (runs against the just-injected DOM)
    const script = document.createElement('script');
    script.setAttribute('data-mkt', '1');
    script.textContent = bundle.js;
    document.body.appendChild(script);

    return () => {
      try { if (typeof window.__mktCleanup === 'function') window.__mktCleanup(); } catch { /* noop */ }
      document.querySelectorAll('[data-mkt="1"]').forEach((n) => n.remove());
      if (hostRef.current) hostRef.current.innerHTML = '';
      document.title = prevTitle;
      delete window.__MKT_API;
    };
  }, []);

  return <div ref={hostRef} data-testid="marketing-site" />;
}
